import { render } from "./WhatWeDo.vue?vue&type=template&id=c21a4b94&scoped=true"
import script from "./WhatWeDo.vue?vue&type=script&lang=js"
export * from "./WhatWeDo.vue?vue&type=script&lang=js"

import "./WhatWeDo.vue?vue&type=style&index=0&id=c21a4b94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21a4b94"]])

export default __exports__